import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { defaultWebsockets } from "../config";

const WebSocketPerformanceBase = ({ setFastestWebSocket }) => {
  const [results, setResults] = useState([]);
  const [fastest, setFastest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("Running WebSocket tests after initial delay...");

    const testWebsockets = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Delay testing by 2 seconds

      const performanceResults = await Promise.all(
        defaultWebsockets.map(async (url) => {
          if (!url) return { url: "❌ Undefined URL", latency: Infinity };

          console.log(`Testing WebSocket: ${url}`);
          const start = performance.now();
          let latency = null;
          let provider = null;

          try {
            provider = new ethers.providers.WebSocketProvider(url);

            await new Promise((resolve, reject) => {
              provider._websocket.onopen = () => {
                latency = performance.now() - start;
                console.log(`✅ ${url} - Latency: ${latency.toFixed(2)} ms`);
                resolve();
              };
              provider._websocket.onerror = (error) => {
                console.error(`❌ Error testing ${url}:`, error.message);
                reject(new Error("WebSocket connection failed"));
              };
              setTimeout(() => reject(new Error("WebSocket Timeout")), 5000);
            });
          } catch (error) {
            console.error(`❌ WebSocket failed: ${url}`, error.message);
            latency = Infinity;
          } finally {
            if (provider) {
              provider.removeAllListeners(); // Remove all event listeners
              if (provider._websocket && typeof provider._websocket.terminate === "function") {
                provider._websocket.terminate(); // Forcefully close the WebSocket connection
              }
            }
          }

          return { url, latency };
        })
      );

      performanceResults.sort((a, b) => a.latency - b.latency);
      setResults(performanceResults);
      setLoading(false);

      // Find the fastest WebSocket
      const bestWebSocket = performanceResults.find((result) => result.latency !== Infinity);
      if (bestWebSocket) {
        setFastest(bestWebSocket.url);
      }
    };

    testWebsockets();
  }, []);

  // Delay passing the fastest WebSocket by 3 seconds
  useEffect(() => {
    if (fastest) {
      console.log(`✅ Fastest WebSocket found: ${fastest}, waiting before setting...`);
      const delayTimeout = setTimeout(() => {
        console.log(`🚀 Passing WebSocket to parent: ${fastest}`);
        setFastestWebSocket(fastest);
      }, 3000); // 3 seconds delay before passing it

      return () => clearTimeout(delayTimeout);
    }
  }, [fastest, setFastestWebSocket]);

  return null;
};

export default WebSocketPerformanceBase;
